/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_SearchInputs */

const id_tld_pricing_search = /** @type {(inputs: Tld_Pricing_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari TLD`)
};

const en_tld_pricing_search = /** @type {(inputs: Tld_Pricing_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search TLDs`)
};

/**
* | output |
* | --- |
* | "Search TLDs" |
*
* @param {Tld_Pricing_SearchInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_search = /** @type {((inputs?: Tld_Pricing_SearchInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_SearchInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_search(inputs)
	return id_tld_pricing_search(inputs)
});